import { UpsellingSelection } from 'services/api/entities/events/types/internal/selections'
import { YupSchema } from 'services/yup'
import { productSelectionBaseVS } from './common/base'

export const upsellingSelectionVS: YupSchema<UpsellingSelection> =
  productSelectionBaseVS
